import { render } from "./HeroiconsSolidSearch.vue?vue&type=template&id=6a848d40"
const script = {}

import exportComponent from "/var/www/html/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidSearch.vue"]])

export default __exports__